// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"19b20f53","497":"9c659a26","578":"adb2c84c","641":"1a888c65","705":"7fec1768","778":"b751479a","884":"0f168591"}[chunkId] + ".chunk.js";
};